var baseFontSize = 16;
export default (function (px) {
  return parseFloat(px) / baseFontSize;
});